<template>
  <div class="IECATable">
    <v-container grid-list-md fluid fill-height>
      <v-layout row wrap justify-center>
      <v-flex xs12>
        <v-card>
          <v-expansion-panel
            v-model="panel"
            expand
            popout
          >
            <v-expansion-panel-content>
              <template v-slot:header>
                <v-card-title class="title">
                  Aplicar Filtros
                </v-card-title>
              </template>
              <v-card>
                <v-card-text>
                  <!--Fecha fitiros -->
                  <v-layout wrap justify-space-between>
                    <v-flex xs12 md3>
                      <v-menu
                        :close-on-content-click="false"
                        v-model="menuIni"
                        transition="scale-transition"
                        offset-y
                        full-width
                        :nudge-right="40"
                        max-width="290px"
                        min-width="290px"
                        :disabled="loadingFuida"
                      >
                        <v-text-field
                          slot="activator"
                          label="Fecha Inicial"
                          v-model="dateIni"
                          prepend-icon="event"
                          readonly
                          hint="Debe ser anterior a la fecha final"
                          persistent-hint
                        ></v-text-field>
                        <v-date-picker
                          v-model="dateIni"
                          locale="es-CO"
                          no-title
                          scrollable
                          actions
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-spacer/>
                    <v-flex xs12 md3>
                      <v-menu
                        :close-on-content-click="false"
                        v-model="menuEnd"
                        transition="scale-transition"
                        offset-y
                        full-width
                        :nudge-right="40"
                        max-width="290px"
                        min-width="290px"
                        :disabled="loadingFuida"
                      >
                        <v-text-field
                          slot="activator"
                          label="Fecha Final"
                          v-model="dateEnd"
                          prepend-icon="event"
                          readonly
                          hint="Debe ser posterior a la fecha inicial"
                          persistent-hint
                        ></v-text-field>
                        <v-date-picker
                          v-model="dateEnd"
                          locale="es-CO"
                          no-title
                          scrollable
                          actions
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-spacer/>
                  </v-layout>
                    <!--Encuestador fitiros -->
                  <v-layout wrap justify-space-between>
                    <v-flex xs12 md3>
                        <v-text-field
                          slot="activator"
                          label="Encuestador"
                          v-model="encuestador"
                          type="text"
                          prepend-icon="person"
                          :disabled="loadingFuida"
                        ></v-text-field>
                    </v-flex>
                    <v-spacer/>
                  <!--codigo fitiros -->
                    <v-flex xs12 md3>
                        <v-text-field
                          slot="activator"
                          label="Codigo"
                          v-model="codigo"
                          prepend-icon="person"
                          :disabled="loadingFuida"
                        ></v-text-field>
                    </v-flex>
                    <v-spacer/>
                  </v-layout>
                  <!--caja siars fitiros -->
                  <v-layout wrap justify-space-between>
                    <v-flex xs12 md3>
                        <v-text-field
                          slot="activator"
                          label="Caja siars"
                          v-model="caja_siar"
                          prepend-icon="person"
                          :disabled="loadingFuida"
                        ></v-text-field>
                    </v-flex>
                    <v-spacer/>
                    <!--cja iron fitiros -->
                    <v-flex xs12 md3>
                        <v-text-field
                          slot="activator"
                          label="Caja iron"
                          v-model="caja_iron"
                          prepend-icon="person"
                          :disabled="loadingFuida"
                        ></v-text-field>
                    </v-flex>
                    <v-spacer/>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-card-actions>
            <v-spacer/>
            <v-btn color="warning"
              :disabled="loadingFuida"
              @click="clear()"
            >
              Limpiar
            </v-btn>

            <v-btn
              color="info"
              :disabled="loadingFuida || loadingTable || vDate"
              @click="loadData()"
            >
              <v-icon left>cloud_download</v-icon> {{ btnText }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
        <v-flex md10>
          <v-card class="mb-2">
            <v-card-title class="title">
              FUID
              <v-spacer/>

              <v-card-actions>
                <v-btn color="info" :disabled="dataVals === null">
                  <download-csv
                    :data="dataVals"
                    name="fuida.csv"
                    :labels="labels"
                  >
                    <v-icon left style="vertical-align: middle">cloud_download</v-icon>csv
                  </download-csv>
                </v-btn>
              </v-card-actions>
            </v-card-title>

            <v-card-text
              v-if="loadingFuida"
              class="text-xs-center"
            >
              <v-progress-circular
                :size="progressSize"
                :width="progressWidth"
                color="info"
                indeterminate
              ></v-progress-circular>
            </v-card-text>

            <v-card-text v-else>
              <data-table
                :headers="headers"
                :dataVals="dataVals"
                :items="dataVals"
                :searchActive="true"
                :key="tableKey"
              />
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import dataTable from '@/components/Tables/TableBase'
import JsonCSV from 'vue-json-csv'
import moment from 'moment'

export default {
  name: 'IECATable',

  components: {
    'data-table': dataTable,
    'download-csv': JsonCSV
  },

  /**
   * Esta función carga el respectivo Layout, al crear la vista.
   */
  created () {
    this.$store.commit('SET_LAYOUT', 'dashboard-layout')
    this.operativo = this.$store.state.actualOperation.id
  },

  data: function () {
    return {
      backConf: {
        path: '/projects/ieca_tb/',
        page: 1
      },

      loadingFuida: false,
      loadingTable: false,
      progressSize: 70,
      progressWidth: 7,

      operativo: null,

      panel: [false],

      dateIni: null,
      dateEnd: null,
      encuestador: null,
      codigo: null,
      caja_siar: null,
      caja_iron: null,
      filter: [],

      arreglo: [],

      filterBy: null,

      headers: [
        { text: 'Fecha_End', value: 'Fecha_End', align: 'left' },
        { text: 'Encuestador', value: 'Encuestador', align: 'left' },
        { text: 'Codigo_carpeta_ik', value: 'Codigo_carpeta_ik', align: 'left' },
        { text: 'Codigo_carpeta', value: 'Codigo_carpeta', align: 'left' },
        { text: 'Dependencia', value: 'Dependencia', align: 'center' },
        { text: 'Titulo', value: 'Titulo', align: 'center' },
        { text: 'Inicial', value: 'Inicial', align: 'center' },
        { text: 'Final', value: 'Final', align: 'center' },
        { text: 'Caja_Siar', value: 'Caja_Siar', align: 'center' },
        { text: 'Caja_otros', value: 'Caja_otros', align: 'center' },
        { text: 'Caja_Iron', value: 'Caja_Iron', align: 'center' },
        { text: 'Tipo', value: 'Tipo', align: 'center' },
        { text: 'Otro_tipo', value: 'Otro_tipo', align: 'center' },
        { text: 'Folios', value: 'Folios', align: 'center' },
        { text: 'Soporte', value: 'Soporte', align: 'center' },
        { text: 'Otro_soporte', value: 'Otro_soporte', align: 'center' },
        { text: 'Nota', value: 'Nota', align: 'center' },
        { text: 'Imagen', value: 'Imagen', align: 'center' }
      ],

      dataVals: null,
      tableKey: 0
    }
  },
  computed: {
    /**
     * Verifica que la fecha final no sea anterior a la fecha inicial
     * @return {string} validación de las fechas
     */
    vDate: function vDate () {
      if (this.dateIni && this.dateEnd) {
        return moment(this.dateEnd).isBefore(this.dateIni)
      }
      return false
    },

    /**
     * Determina el texto que tendra el boton
     * @return {boolean} Texto poara poner en el boton
     */
    btnText: function btnText () {
      if (!this.dateIni && !this.dateEnd && !this.encuestador && !this.codigo && !this.caja_siar && !this.caja_iron) {
        return 'Cargar Todos'
      }
      return 'Cargar con Filtro'
    },

    /**
     * Genera el objeto para realizar la consulta
     * @return {Object} Objeto de la forma id[field]:id[choice]
     */
    filterToApply: function filterToApply () {
      if (this.filter.length < 1) {
        return null
      }

      let obj = {}

      this.filterBy.forEach(function (filt, index) {
        obj[filt.id] = this.filter[index]
      }, this)
      return obj
    }
  },

  methods: {
    /** Carga la tabla
     */
    loadTable () {
      this.arreglo = null
      this.loadingFuida = true
      this.dataVals = null
      let request = {
        method: 'get',
        url: this.backConf.path,
        params: {
          fechainicio: this.dateIni,
          fechafin: this.dateEnd,
          encuestador: this.encuestador,
          codigo: this.codigo,
          caja_siar: this.caja_siar,
          caja_iron: this.caja_iron,
          filtro: this.filterToApply
        }
      }

      let t = this

      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.arreglo = resp.data
          t.loadingFuida = false
          t.tableKey += 1
          let cant = [] // datos para tabla
          if (t.arreglo.length > 0) {
            t.arreglo.forEach(function (element) {
              if (element['Imagen'] == null) {
                element['Imagen'] = 'No disponible'
              }
              cant.push(element)
            })
          }
          t.dataVals = cant
        })
        .catch(function (err) {
          console.error(err)
          t.dataVals = []
          t.loadingFuida = false
        })
    },
    loadFiltro () {
      let request = {
        method: 'get',
        url: this.backConf.path,
        params: {
          operativo: this.operativo,
          tipo: 'filtro'
        }
      }
      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.filterBy = resp.data
        })
        .catch(function (err) {
          t.filterBy = null
          console.error(err)
        })
    },
    loadData () {
      this.loadTable()
      this.panel = [false]
    },
    clear () {
      this.dateIni = null
      this.dateEnd = null
      this.encuestador = null
      this.codigo = null
      this.caja_siar = null
      this.caja_iron = null
      this.filter = []
    }
  }
}
</script>
